import {useCallback, useMemo, useState} from 'react';
import {useCommentSalesDoc} from '../../../hooks/api';
import {SESSION_EXPIRED_MESSAGE} from '../../../hooks';

export const useComment = ({id, prefix, successMessage, onSuccess}) => {
  const {comment: commentSalesDocAPI, isInProgress: savingComment} = useCommentSalesDoc();
  const [commentText, setCommentText] = useState('');

  const saveComment = useCallback(async () => {
    const res = await commentSalesDocAPI({id, comment: prefix ? `${prefix} ${commentText}` : commentText}, {successMessage, errorMessage: ({status, message}) => status === 403 ? SESSION_EXPIRED_MESSAGE : message});
    if (res) {
      setCommentText('');
      onSuccess?.();
    }
  }, [id, commentSalesDocAPI, commentText, onSuccess, prefix, successMessage]);

  return useMemo(() => ({commentText, setCommentText, savingComment, saveComment}), [commentText, setCommentText, savingComment, saveComment]);
};

